import NoDataComponent from '@Components/General/Feedback/no-data-component';
import { AddCircleOutlineRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const NoDesigns = () => {
    const { t } = useTranslation();

    return (
        <NoDataComponent
            primary={t('prompts:noData.emailDesigns.noData.primary')}
            secondary={t('prompts:noData.emailDesigns.noData.secondary')}
            Icon="interests"
            action={
                <Button
                    startIcon={<AddCircleOutlineRounded />}
                    color="primary"
                    LinkComponent={Link}
                    to="new"
                >
                    {t('Create Design')}
                </Button>
            }
        />
    );
};

export default NoDesigns;
